import config from '../api/constants'
import http from '../api/api'

const getLocations = async (data) => {
  try {
    const req = {
      ...data,
    }
    const response = await http.get(config.apiRoute.GET_LOCATIONS, req)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const BranchService = {
  getLocations
}

export default BranchService
